import type { SortingState } from '@tanstack/react-table';
import type { SortOptions } from '../../../utilities/customSorting';

/** TanStack column sort options (pairs with `sortUndefined: false` on custom `sortingFn` columns). */
export type TanStackSortOptions = SortOptions & {
  direction: 'asc' | 'desc';
};

/** TanStack runs `sortUndefined` before `sortingFn` — disable on columns with custom `sortingFn`. */
export const tanStackCustomColumnSort = { sortUndefined: false as const };

export const getSortDirection = (
  sortingState: SortingState | undefined,
  columnId: string,
): 'asc' | 'desc' => {
  const item = sortingState?.find((s) => s.id === columnId);
  return item?.desc ? 'desc' : 'asc';
};

export const tanStackSortOptions = (
  sorting: SortingState,
  columnId: string,
): TanStackSortOptions => ({
  emptyLast: true,
  direction: getSortDirection(sorting, columnId),
});
